import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import _includes from 'lodash-es/includes';
import _forEach from 'lodash-es/forEach';
import _keys from 'lodash-es/keys';
import _cloneDeep from 'lodash-es/cloneDeep';
import _get from 'lodash-es/get';
import _unset from 'lodash-es/unset';
import _set from 'lodash-es/set';
import _lowerCase from 'lodash-es/lowerCase';
import _toString from 'lodash-es/toString';
import _startsWith from 'lodash-es/startsWith';
import _find from 'lodash-es/find';
import _replace from 'lodash-es/replace';
import _uniq from 'lodash-es/uniq';

import * as moment from 'moment';

import { PropalService } from 'app_locobook/service/propal/propal.service';
import { SSRService } from 'app_locobook/ssr/ssr.service';
import { PlainTextService } from 'libraries/service/plainText/plainText.service';
import { CustomFieldService } from "../customField/customField.service";

import { IWenji } from "libraries/interfaces/IWenji";
import { TravellerService } from "libraries/service/traveller/traveller.service";
import { ILink } from "libraries/service/resources/sam/ISamLink";
import { ISamCompany } from "libraries/service/resources/sam/ISamCompany";
import { ISamAgent } from "libraries/service/resources/sam/ISamAgent";
import { AirBookingResourceService } from 'libraries/service/resources/air-booking/air-booking-resource.service';
import { Observable, of } from 'rxjs';
import { IAirDisplay } from './IAirDisplay';
import {
    IAirCreateBookingRequest,
    IAirCreateBookingRequestAgency,
    IAirCreateBookingRequestAgent,
    IAirCreateBookingRequestOsi,
    IAirCreateBookingRequestSegment,
    IOnBookingCreationFailedNotificationSetup,
    IOnBookingCreatedNotificationSetup,
    IOnOfferSelectedNotificationSetup,
    IAirCreateBookingRequestPayment,
    IAirUpdateBookingRequest,
    IAirUpdateBooking,
    IAirCreateBookingRequestTraveller,
    IAirUpdateBookingTask, IAirCreateBookingRequestFareFamily
} from 'libraries/service/resources/model/booking/air/IAirCreateBooking';
import {
    IGetBookingsAirResponse,
    ISectorAir,
    ITraveller
} from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { INotepad } from "libraries/service/resources/booking/interfaces/notepad.interface";
import { EIdentityInfoType } from "libraries/component/identity-info-editor/identity-info-editor.interface";
import { IAirTotal } from "libraries/service/resources/model/search/air/IAirTotal";
import { PostExtraService } from "app_locobook/service/post-extra.service";
import { ActionQualityHelperService } from "libraries/service/action-quality-helper/action-quality-helper.service";
import { ActionInBookingType, ActionType } from "@afidium/ts-facade";
import {
    IAirQuotedAvailabilityResponse
} from "libraries/service/resources/model/booking/air/IAirQuotedAvailabilityResponse";
import { IAirExternalBooking } from "libraries/service/resources/model/booking/air/IAirExternalBooking";
import {
    CacheQuotedAvailabilityService
} from "app_locobook/service/cache-quoted-availability/cache-quoted-availability.service";
import { SentryService } from "libraries/service/sentry/sentry.service";
import { AirBookingCreatePaymentService } from "libraries/service/booking/air-booking-create-payment.service";

/**
 * service for {{host}}/{{instance}}/api/air/bookings/create transaction
 */

declare var wenji: IWenji;
declare var document: any;

@Injectable()
export class PNRService {

    //var to be used in components
    /**
     * @deprecated Use the observable instead
     */
    public response: any = {data: {}, display: {}, message: ""};

    public RQ: IAirCreateBookingRequest;
    private propalResponse: any;
    private readonly ssrResponse: any;
    private readonly CFResponse: any;

    private readonly dummy = true;
    private readonly dev = JSON.parse(sessionStorage.getItem('dev')); // true = use jsonblob, for DEV only
    private readonly lsPrefix = sessionStorage.getItem("$instance_url");

    private readonly function;     //7bf89dab-b648-11e6-871b-5b1a153795cf

    constructor(
        private readonly location: Location,
        private readonly customFieldService: CustomFieldService,
        private readonly plainTextService: PlainTextService,
        private readonly travellerService: TravellerService,
        private readonly airBookingResource: AirBookingResourceService,
        private readonly propalService: PropalService,
        private readonly sentryService: SentryService,
        ssrService: SSRService,
        private readonly postExtraService: PostExtraService,
        private readonly actionQualityHelperService: ActionQualityHelperService,
        private readonly cacheQuotedAvailabilityService: CacheQuotedAvailabilityService,
        private readonly createBookingPaymentStorageService: AirBookingCreatePaymentService,
    ) {
        this.propalResponse = propalService.propalResponse;
        this.ssrResponse = ssrService.response;
        this.location = location;
        this.CFResponse = customFieldService.response;
    }

    public initPropalResponse(): void {
        this.propalResponse = this.propalService.propalResponse;
    }


    /**
     * API function to get all the Quotes from key
     */
    public createBooking(request: IAirCreateBookingRequest): Observable<{
        request: IAirCreateBookingRequest; response: IGetBookingsAirResponse; display: IAirDisplay
    }> {
        this.customFieldService.getCustomField();

        const target: string = wenji.ui.target;

        //reset response because of new request
        this.response.data = {};
        this.response.display = {};
        this.response.message = "";
        // return of();

        return this.airBookingResource.create(request, target).pipe(
            map((response: IGetBookingsAirResponse): { request: IAirCreateBookingRequest; response: IGetBookingsAirResponse; display: IAirDisplay } => {
                this.storeBooking(response);

                return {
                    response,
                    display: this.generateDisplay(response),
                    request
                };
            })
        );
    }

    /**
     * set the RQ to send
     */
    public buildRequest(_isTravellerEditable: boolean = true,
                        agent?: ISamAgent,
                        company?: ISamCompany,
                        note?: INotepad[],
                        onBookingCreatedNotificationArray?: IOnBookingCreatedNotificationSetup[],
                        onOfferSelectedNotificationArray?: IOnOfferSelectedNotificationSetup[],
                        onBookingCreationFailedNotificationArray?: IOnBookingCreationFailedNotificationSetup[],
                        isLowcost?: boolean,
                        externalBooking?: IAirExternalBooking,
                        vendor?: object,
                        serviceSelection?: any
    ): IAirCreateBookingRequest {
        this.createBookingPaymentStorageService.resetPayment();
        this.response.data = {};
        this.response.display = {};
        this.response.message = "";
        //define booking data
        // const booking = this.propalResponse.data.booking[this.propalResponse.display.booking];
        // const transactionId = this.propalResponse.transactionId || booking.transactionId;
        const booking = this.propalResponse.data.selectedQuote;
        if (!booking) {
            this.sentryService.logDataSentryError(this.propalResponse.data, 'Log propalResponse to reproduce, #33820');
        }
        const transactionId: string = booking.transactionId;
        //original datas
        const $post = JSON.parse(sessionStorage.getItem('$post'));

        let data: any;
        data = $post || this.propalResponse.searchForm || this.propalResponse.searchRQ;
        if (data?.body) {
            data = data.body;
        }
        const simpleAgent = this.getSimpleParam('agent', data);
        const simpleAgency: any = this.getSimpleParam('agency', data);

        if (Boolean(vendor) && typeof vendor === 'string') {
            vendor = {code: vendor};
        }

        // const osifromRQ: any = this.getSimpleParam('osi', data)? this.getSimpleParam('osi', data): [];
        let request: IAirCreateBookingRequest;
        if (this.cacheQuotedAvailabilityService.hasBookingWithServiceSelectionRequest()) {
            request = {
                ...this.cacheQuotedAvailabilityService.getBookingWithServiceSelectionRequest(),
                price: {
                    ...this.getPrice(booking),
                    value: this.createBookingPaymentStorageService.extractFullTotalPriceFromServiceSelection(serviceSelection).value,
                    total: this.createBookingPaymentStorageService.extractFullTotalPriceFromServiceSelection(serviceSelection).value,
                },
                osi: this.getSimpleParam('osi', data),
                brand: this.getSimpleParam('brand', data),
                customer: this.getSimpleParam('customer', data),
                // fareFamily: booking.fareFamily !== {} ? booking.fareFamily : null,
                // @ts-ignore
                // fareFamilyServices: this.cacheQuotedAvailabilityService.getBookingWithServiceSelectionRequest().fareFamily,
                keyword: booking.keyword || data.keyword?.join(),
                locator: data.locator,
                customField: this.getSimpleParam('customField', data),
                traveller: this.getTraveller(_isTravellerEditable),
                note,
                onBookingCreatedNotificationArray,
                onOfferSelectedNotificationArray,
                onBookingCreationFailedNotificationArray,
                postExtra: this.postExtraService.getPostExtra(),
                actionArray: this.actionQualityHelperService.extractActionsForQuotedAvailabilityTrip(booking.serviceArray || booking.actionArray),
                // payment: isLowcost ? this.createBookingPaymentStorageService.computePayment(booking, data, serviceSelection) : null,
                externalBooking,
                vendor,
            };
            this.createBookingPaymentStorageService.setPayment(this.createBookingPaymentStorageService.computePayment(booking, data, serviceSelection));

        } else {
            request = {
                price: this.getPrice(booking),
                osi: this.getSimpleParam('osi', data),
                brand: this.getSimpleParam('brand', data),
                transactionId,
                agent: !simpleAgent || simpleAgent.length === 0 ? createAgentFromSamAgent(agent) : simpleAgent,
                agency: this.buildAgency(company, simpleAgency),
                customer: this.getSimpleParam('customer', data),
                customField: this.getSimpleParam('customField', data),
                traveller: this.getTraveller(_isTravellerEditable),
                // For the moment, booking.host is empty if only 1 host has been requested
                // TODO: remove || data.host once it'll be fixed in wenji
                host: booking.host || data.host,
                segment: this.getSegment(booking),
                ssr: this.getPnrSsr(booking),
                fareFamily: booking.fareFamily !== {} ? booking.fareFamily : null,
                keyword: booking.keyword || data.keyword?.join(),
                locator: data.locator,
                note,
                onBookingCreatedNotificationArray,
                onOfferSelectedNotificationArray,
                onBookingCreationFailedNotificationArray,
                postExtra: this.postExtraService.getPostExtra(),
                actionArray: this.actionQualityHelperService.extractActionsForQuotedAvailabilityTrip(booking.serviceArray || booking.actionArray),
                //
                // payment: isLowcost ? this.createBookingPaymentStorageService.computePayment(booking, data) : null,
                externalBooking,
                vendor,
            };
            this.createBookingPaymentStorageService.setPayment(this.createBookingPaymentStorageService.computePayment(booking, data));

        }

        //remove undefined Values
        const keys: string[] = Object.keys(request);
        for (const key of keys) {
            if (!request[key] || request[key].length === 0) {
                // tslint:disable-next-line:no-dynamic-delete
                delete request[key];
            }
        }
        return request;
    }

    public buildUpdateRequest(booking: IGetBookingsAirResponse, quoteSelected: IAirQuotedAvailabilityResponse): IAirUpdateBookingRequest {
        let traveller: ITraveller[] = [];
        if (booking.traveller?.length) {
            traveller = booking.traveller.map((travellerItem: any): any => {
                if (travellerItem.birthDate && typeof travellerItem.birthDate === "object") {
                    travellerItem.birthDate = moment(travellerItem.birthDate as Date).format('YYYY-MM-DD');
                }
                return travellerItem;
            });
        }
        return {
            host: quoteSelected.host,
            booking: {
                transactionId: quoteSelected.transactionId,
                host: quoteSelected.host,
                syscode: booking.syscode,
                segmentArray: this.getSegment(quoteSelected), //this.makeUpdateBookingSegment(quoteSelected),
                fareType: quoteSelected.fareType,
                fareFamily: this.makeUpdateBookingFareFamily(quoteSelected)
            },
            traveller,
            taskArray: this.makeUpdateBookingTaskArray(quoteSelected)
        };
    }

    // in case need array for segment array
    /*private makeUpdateBookingSegment(quoteSelected: IAirQuotedAvailabilityResponse): IAirCreateBookingRequestSegment {
        const segment: IAirCreateBookingRequestSegment = []
        for (const value of Object.values(quoteSelected.fareFamily)) {
            .segment
    }*/


    /**
     * transform traveller object to an array, for RQ
     * the key become a param
     */
    public getTraveller(_isTravellerEditable: boolean = true): any {
        const output: any = [];

        const keys = _keys(this.propalResponse.traveller);
        for (const key of keys) {

            let copy = {...this.propalResponse.traveller[key]};
            copy.id = key;
            if (!_isTravellerEditable) {
                const apisField: any = [
                    'citizenship',
                    'passport.issuance.country',
                    'passport.number',
                    'passport.validity.end'
                ];

                _forEach(copy, (traveller: any, travellerKey: string) => {
                    //count apis Fields in pax...
                    let nbFieldInTraveller: number = 0;
                    _forEach(apisField, (field: string) => {
                        if (_get(traveller, field)) {
                            nbFieldInTraveller++;
                        }
                    });


                    if (nbFieldInTraveller !== 0 && nbFieldInTraveller !== apisField.length) {
                        _unset(copy, 'passport');
                        _unset(copy, 'passportCitizenship');
                    }

                    if (nbFieldInTraveller === apisField.length && copy.type === 'Adult') {
                        if (!_get(copy, 'birthDate')) {
                            _unset(copy, 'passport');
                            _unset(copy, 'passportCitizenship');
                        }
                    }
                });
            }

            this.propalService.verifyAPIS();

            if (this.propalResponse.display.errorTraveller[key] && this.propalResponse.display.errorTraveller[key].length > 0) {
                if (copy.type === "Adult") {
                    delete copy.birthDate;
                }
                delete copy.passport;
                delete copy.citizenship;
            }

            // define xId if not exist
            if (!copy.xId) {
                _set(copy, 'xId', copy.id);
            }

            //name in lowerCase. bonus : it removes special cars!!
            copy.firstName = _lowerCase(copy.firstName);
            copy.lastName = _lowerCase(copy.lastName);

            //correct date if exist

            const birthDate = _get(copy, 'birthDate');
            if (birthDate && _includes(birthDate, '/')) {
                const date = moment(birthDate, 'DD/MM/YYYY');
                _set(copy, 'birthDate', _toString(date.format('YYYY-MM-DD')));
            }
            if (birthDate && _includes(birthDate, '-')) {
                _set(copy, 'birthDate', _toString(birthDate));
            }

            if (birthDate && moment.isDate(birthDate)) {
                const date = moment(birthDate);
                _set(copy, 'birthDate', _toString(date.format('YYYY-MM-DD')));
            }

            const issuanceDatePassport = _get(copy, ['passport', 'validity', 'passEnd']);
            if (issuanceDatePassport && _includes(issuanceDatePassport, '/')) {
                const date = moment(issuanceDatePassport, 'DD/MM/YYYY');
                _set(copy, ['passport', 'validity', 'passEnd'], _toString(date.format('YYYY-MM-DD')));
            }
            if (issuanceDatePassport && _includes(issuanceDatePassport, '-')) {
                _set(copy, ['passport', 'validity', 'passEnd'], issuanceDatePassport);
            }
            if (issuanceDatePassport && moment.isDate(issuanceDatePassport)) {
                const date = moment(issuanceDatePassport);
                _set(copy, ['passport', 'validity', 'passEnd'], _toString(date.format('YYYY-MM-DD')));
            }

            const issuanceDateCard = _get(copy, ['identityCard', 'validity', 'cardEnd']);
            if (issuanceDateCard && _includes(issuanceDateCard, '/')) {
                const date = moment(issuanceDateCard, 'DD/MM/YYYY');
                _set(copy, ['identityCard', 'validity', 'cardEnd'], _toString(date.format('YYYY-MM-DD')));
            }
            if (issuanceDateCard && _includes(issuanceDateCard, '-')) {
                _set(copy, ['identityCard', 'validity', 'cardEnd'], issuanceDateCard);
            }
            if (issuanceDateCard && moment.isDate(issuanceDateCard)) {
                const date = moment(issuanceDateCard);
                _set(copy, ['identityCard', 'validity', 'cardEnd'], _toString(date.format('YYYY-MM-DD')));
            }
            copy = this.prepareIdentityInfo(copy);
            this.travellerService.removeEmpty(output);
            output.push(copy);
        }
        output.forEach((traveller) => {
            this.travellerService.removeEmpty(traveller);
        });

        return output;
    }

    // no type available :-(
    // tslint:disable-next-line:no-any
    public prepareIdentityInfo(data: any): any {
        const renamePropertyLabel: { [key: string]: string } = {
            citizenShip: 'citizenship',
        };
        if (data.identityType === EIdentityInfoType.passport) {

            if (data.passport) {
                data[renamePropertyLabel.citizenShip] = data.passportCitizenship;
                data.passport = {
                    issuance: {country: (data.passport.issuance.passCountry || data.passport.issuance.country)},
                    validity: {end: (data.passport.validity.passEnd || data.passport.validity.end)},
                    number: (data.passport.passNumber || data.passport.number),
                };
                delete data.passportCitizenship;
                delete data.passport.issuance.passCountry;
                delete data.passport.validity.passEnd;
                delete data.passport.passNumber;
            }


        } else {
            delete data.passportCitizenship;
            delete data.passport;
        }

        if (data.identityType === EIdentityInfoType.identityCard) {
            if (data.identityCard) {
                data[renamePropertyLabel.citizenShip] = data.identityCardCitizenship;
                data.identityCard = {
                    issuance: {country: (data.identityCard.issuance.cardCountry || data.identityCard.issuance.country)},
                    validity: {end: (data.identityCard.validity.cardEnd || data.identityCard.validity.end)},
                    number: (data.identityCard.cardNumber || data.identityCard.number),
                };
                delete data.identityCardCitizenship;
                delete data.identityCard.issuance.cardCountry;
                delete data.identityCard.validity.cardEnd;
                delete data.identityCard.cardNumber;
            }

        } else {
            delete data.identityCardCitizenship;
            delete data.identityCard;
        }

        if (data.identityType === EIdentityInfoType.secureFlightPassengerData) {
            data.secureFlightPassengerData = {
                // mock data here because real SFPD data are extracted from the traveller on backend side
                withSfpd: true
            };
        } else {
            delete data.secureFlightPassengerData;
        }

        delete data.identityType;
        return data;
    }

    public getCostPrice(booking: any): number {
        if (!booking.total) {
            return 0;
        }
        const value: number = booking.total.find((totalItem: IAirTotal) => {
            return totalItem.xType === 'cost';
        }).value;

        return value;
    }

    public getCostPriceWithCurrency(booking: any): string {
        if (!booking.total) {
            return '';
        }

        const price: any = booking.total.find((totalItem: IAirTotal) => {
            return totalItem.xType === 'cost';
        });

        return price.amount + ' ' + price.currency;
    }

    /**
     * get segments data for RQ
     * needs : simplify some datas
     */
    public getSegment(booking: any): IAirCreateBookingRequestSegment {
        const bookingClone = _cloneDeep(booking);
        const output: IAirCreateBookingRequestSegment = {};

        const segments: any[] = Object.values(bookingClone.segment);
        const nbSegment: number = segments.length;
        for (let i = 0; i < nbSegment; i++) {

            //transfer selected journey Data in segment root
            const segmentKey = segments[i].xId;
            const journeyKey = this.propalResponse.data.selectedQuoteJourneys[i];
            const journeyValue = segments[i][journeyKey];
            output[segmentKey] = journeyValue;

            //simplify root datas
            output[segmentKey].stop = output[segmentKey].sector.length - 1;
            output[segmentKey].xId = bookingClone.segment[segmentKey].xId;

            //simplify sectors data
            let j = 0;
            for (const sectorItem of journeyValue.sector) {
                if (sectorItem.carrier) {
                    sectorItem.carrier = sectorItem.carrier.code;
                }
                if (sectorItem.seat) {
                    sectorItem.seat = Object.keys(sectorItem.seat)[0];
                }
                output[segmentKey].sector[j] = sectorItem;

                j++;
            }

        }

        return output;
    }


    /*
    * set SSR list for API create booking
    */
    public getPnrSsr(booking): any {
        const keys = Object.keys(this.ssrResponse.selected);

        const output: any[] = [];
        for (const key of keys) {

            const carriers: any[] = [];

            this.propalResponse.display.segments
                .forEach((segmentId: string, index: number): void => {
                    const journeyId: string = this.propalResponse.data.selectedQuoteJourneys[index];
                    booking.segment[segmentId][journeyId].carrier
                        .forEach((carrierItem: any): void => {
                            carriers.push(carrierItem.code);
                        });
                });

            const carrierList: string[] = _uniq(carriers);
            for (const carrier of carrierList) {
                const copy = _cloneDeep(this.ssrResponse.selected[key]);
                copy.carrier = carrier;
                output.push(copy);
            }
        }
        return output;

    }


    /**
     * get number or sectors
     *
     */
    public countSectors(): number {
        return _keys(this.response.sector).length;
    }

    private generateDisplay(booking: IGetBookingsAirResponse): IAirDisplay {
        const defaultDisplay: IAirDisplay = {
            ssr: false,
            itineraryPlainText: "",
            nbDecodedSSR: 0
        };

        return generateDisplaySSR(booking,
            this.generatePlainText(booking.sector, defaultDisplay));
    }

    private storeBooking(response: IGetBookingsAirResponse) {
        this.response.data = response;

        const host: string = response.host;
        const code: string = response.code;

        this.location.replaceState(`locobook/pnr/${host}/${code}`);

        if (!this.response.data) { //if API erreur
            this.response.message = "Erreur API";
        }


        this.response.display = this.generateDisplay(response);
        // this.getCustomFieldData();

        if (this.countSectors() > 3 && this.response.display.ssr) {

            const wrapper = document.getElementById('app-wrapper');
            wrapper.classList.add("full-wrapper");

        }
    }

    /**
     * used by getQuote to store response
     */
    private storeResult(res: any) {
        const result = res.data;
        this.storeBooking(result);
    }


    /**
     *  get Price for RQ
     **/
    public getPrice(booking: any): any {
        const output: any = {};

        output.role = "Total";
        output.fareType = booking.fareType;
        const hasRetailPrice: boolean = booking.total.some((totalItem: IAirTotal) => totalItem.xType === "retail");
        const value: number = booking.total.find((totalItem: IAirTotal) => {
            const xType: "retail" | "cost" = hasRetailPrice ? "retail" : "cost";
            return totalItem.xType === xType;
        }).value;
        output.value = value;
        output.total = value;

        return output;
    }

    /**
     *  get Price from services Validation Response
     **/
    private getPriceFromQu(booking: any): any {
        const output: any = {};

        output.role = "Total";
        output.fareType = booking.fareType;
        const hasRetailPrice: boolean = booking.total.some((totalItem: IAirTotal) => totalItem.xType === "retail");
        const value: number = booking.total.find((totalItem: IAirTotal) => {
            const xType: "retail" | "cost" = hasRetailPrice ? "retail" : "cost";
            return totalItem.xType === xType;
        }).value;
        output.value = value;
        output.total = value;

        return output;
    }

    /**
     * get a param from $post or services
     */
    private getSimpleParam(param: any, source: any): any {
        let output: any = {};
        output = source[param];
        return output;
    }

    private getOsiFromActionArray(actionArray: ActionType[]): IAirCreateBookingRequestOsi[] {
        if (!actionArray?.length) {
            return [];
        }
        const quoteAction: ActionType = actionArray
            .find((action: ActionType): boolean => action.xCode === "QuotedAvailability");

        if (quoteAction) {
            const tripAction: ActionInBookingType = quoteAction.actionArray
                .find((action: ActionInBookingType): boolean => action.xCode === "Trip" && !action.xMatch);
            if (tripAction?.actionArray) {
                const osiAction: ActionInBookingType = tripAction.actionArray.find((action: ActionInBookingType): boolean => action.qualification === "OSI_TO");
                if (osiAction && !osiAction.xMatch) {
                    return osiAction.textLineArray
                        .map((line: string): IAirCreateBookingRequestOsi => {
                            const parts: string[] = line.split('*');
                            return {
                                text: parts[1],
                                carrier: parts[0],
                            };
                        });
                }
            }
            return [];
        }
        return [];
    }

    /**
     * get a param from $post or services
     */
    private getAgent(source: any, link?: ILink): any {
        //use simpleParam ...
        let output: any = {};
        const fromSource = this.getSimpleParam('agent', source);


        //... if getSimpleParam return an empty value, get it from Token
        if (!fromSource || fromSource.length === 0) {

            const user = JSON.parse(localStorage.getItem(this.lsPrefix + "_userInformations"));
            //output: any = {};
            output.firstName = user.sam_contact.firstName;
            output.lastName = user.sam_contact.lastName;

            //to avoid API error, duplicate lastname into firstname if not exist,
            if (!output.firstName) {
                output.firstName = output.lastName;
            }
            //to avoid API error, duplicate firstname into lastname if not exist,
            if (!output.lastName) {
                output.lastName = output.firstName;
            }

        } else { //... or take it from Source
            output = fromSource;
        }
        if (link) {
            output.link = link;
        }
        return output;
    }

    /*
    * get Data from CustomField.json (Yii)
    **/
    private getCustomFieldData(): void {

        this.response.display.customField = {};
        if (this.CFResponse.data.pnr) {

            for (const varKey of Object.keys(this.CFResponse.data.pnr)) {

                const valueToFind = this.CFResponse.data.pnr[varKey].test.value;
                const obj = _find(this.response.note, function (o: any) {
                    return _startsWith(o.text, valueToFind);
                });


                this.response.display.customField[varKey] = _replace(obj.text, valueToFind + ':', '');
            }
        }
    }

    /**
     * Get plainText from sectors list
     */
    private generatePlainText(sector: ISectorAir[], inputDisplay: IAirDisplay): IAirDisplay {
        const output: string = "";

        const itineraryPlainText: string = this.plainTextService.setPlainText(sector);

        return {...inputDisplay, itineraryPlainText};
    }

    private makeUpdateBookingFareFamily(quoteSelected: IAirQuotedAvailabilityResponse): IAirCreateBookingRequestFareFamily {
        let fareFamily: IAirCreateBookingRequestFareFamily;
        for (const value of Object.values(quoteSelected.fareFamily)) {
            fareFamily = {
                sector: value.segment as string[],
                syscode: typeof value.syscode === 'string' ? value.syscode : value.syscode.value
            };
        }
        return fareFamily;
    }

    private makeUpdateBookingTaskArray(quoteSelected: IAirQuotedAvailabilityResponse): IAirUpdateBookingTask[] {
        const taskArray: IAirUpdateBookingTask[] = [
            {
                purpose: 'Add',
                code: 'Segment',
                argumentArray: []
            },
            {
                purpose: 'Add',
                code: 'Price',
                argumentArray: []
            }
        ];

        for (const value of Object.values(quoteSelected.segment)) {
            taskArray[0].argumentArray.push({ref: value.xId, role: 'New'});
        }
        for (const value of Object.values(quoteSelected.price)) {
            taskArray[1].argumentArray.push({ref: this.propalResponse.display.booking, role: 'New'});
        }
        return taskArray;

    }

    private buildAgency(samCompany: ISamCompany, requestAgency: any): IAirCreateBookingRequestAgency {
        if (!requestAgency || requestAgency.length === 0) {
            return samCompany;
        }

        if (requestAgency && !requestAgency.telephone) {
            requestAgency.telephone = samCompany.link.mobile || samCompany.link.phone;
        }
        if (requestAgency && !requestAgency.address && samCompany.address) {
            requestAgency.address = samCompany.address;
        }

        // @ts-ignore
        if (!requestAgency.name && requestAgency.Name) {
            // @ts-ignore
            requestAgency.name = requestAgency.Name;
            // @ts-ignore
            delete requestAgency.Name;
        }
        // @ts-ignore
        if (!requestAgency.code && requestAgency.Code) {
            // @ts-ignore
            requestAgency.code = requestAgency.Code;
            // @ts-ignore
            delete requestAgency.Code;
        }

        return requestAgency;
    }
}


function generateDisplaySSR(booking: IGetBookingsAirResponse, inputDisplay: IAirDisplay): IAirDisplay {
    const result: IAirDisplay = {...inputDisplay};

    result.ssr = false; //means no ssr except APIS
    result.nbDecodedSSR = 0; //nb of API SSR


    _forEach(booking.ssr, (ssrItem: any) => {
        if (!ssrItem.decoded && ssrItem.code.IATA !== 'DOCS') {
            result.ssr = true;
        } else {
            result.nbDecodedSSR++;
        }
    });

    return result;
}


function createAgentFromSamAgent(agent: ISamAgent): IAirCreateBookingRequestAgent {
    return {
        firstName: agent.firstName,
        lastName: agent.lastName,
        name: agent.name,
        ...agent.link && agent.link.email ? {email: agent.link.email} : {},
        ...agent.link && (agent.link.phone || agent.link.mobile) ? {telephone: agent.link.phone || agent.link.mobile} : {},
    };
}
